import type { ReactNode } from "react";

/**
 * Shared intro layout for WhatsApp, Messenger, and Instagram.
 * Callers keep their own connection handlers and pass them as children.
 */
export function ChannelConnectIntro({
  imageSrc,
  title,
  body,
  children,
}: {
  imageSrc: string;
  title: string;
  body?: string;
  children?: ReactNode;
}): React.JSX.Element {
  return (
    <div className="grid justify-items-center gap-5 py-2 text-center" data-testid="channels-connect-step">
      <img
        src={imageSrc}
        alt=""
        width={400}
        height={400}
        className="h-auto w-[min(13.5rem,70vw)] object-contain"
      />
      <div className="grid max-w-md justify-items-center gap-2">
        <h2 className="m-0 text-[1.25rem] font-semibold tracking-[-0.02em] text-foreground">{title}</h2>
        {body ? <p className="m-0 text-[0.875rem] leading-relaxed text-muted">{body}</p> : null}
      </div>
      {children ? <div className="grid w-full justify-items-center gap-4">{children}</div> : null}
    </div>
  );
}
